export const paginationSize = '20px'
export const closestPages = 2

export const pageSizeOptions = [
    { value: 10, label: '10' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
]